import { observable } from "mobx"

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type NameGraduatesIn = {
  name: string
  name_kana: string
  sex: string
  birth_year?: number
  birth_month?: number
  birth_date?: number
  year: string
  graduates_in?: number
}

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type Address = {
  zip_code: string
  prefecture_id?: number
  municipality: string
  street_number: string
  building_name_room_number: string
}

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type Education = {
  id: number
  school: string
  faculty: string
  category_id: number
  start_on: string
  end_on: string
  ongoing: boolean
}

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type Qualification = {
  id: number
  display: string
  acquisition_year_month: string
}
interface basicInfoArgs {
  name_graduates_in: NameGraduatesIn
  address: Address
  educations: Education[]
  did_your_best: string
  self_pr: string
  want_to_do: string
  qualifications: Qualification[]
  hobby_skill: string
}

export class BasicInfo {
  @observable name_graduates_in: NameGraduatesIn
  @observable address: Address
  @observable educations: Education[]
  @observable did_your_best: string
  @observable self_pr: string
  @observable want_to_do: string
  @observable qualifications: Qualification[]
  @observable hobby_skill: string

  constructor(args: basicInfoArgs) {
    this.name_graduates_in = args.name_graduates_in
    this.address = args.address
    this.educations = args.educations
    this.did_your_best = args.did_your_best
    this.self_pr = args.self_pr
    this.want_to_do = args.want_to_do
    this.qualifications = args.qualifications
    this.hobby_skill = args.hobby_skill
  }
}
